import { Redirect, RouteProps } from 'react-router-dom';
import React, { FC } from 'react';
import { useAtomValue } from 'jotai';
import { ServiceType, PortalTab } from '@idk-web/api';
import { portalCompany, portalLoginStatus } from '@/state/portalAuth';
import { SentryRoute } from '@/sentry';
import routes from '@/components/portal/routes';

export type UnauthenticatedRouteProps = RouteProps;

/**
 * A route which redirects to the portal app if the current user is logged in.
 */
const UnauthenticatedRoute: FC<UnauthenticatedRouteProps> = (props) => {
  const loginStatus = useAtomValue(portalLoginStatus);
  const company = useAtomValue(portalCompany);

  if (company && loginStatus === 'AUTHENTICATED') {
    const services = company.services.map((e) => e.type);
    const hasTeleId = services.includes(ServiceType.TELEID);
    const hasTeleSign = services.includes(ServiceType.TELESIGN);
    const hasSafeMail = services.includes(ServiceType.SAFEMAIL);

    if (company.defaultStartTab === PortalTab.TELEID && hasTeleId) {
      return <Redirect to={routes.teleid} />;
    } else if (company.defaultStartTab === PortalTab.TELESIGN && hasTeleSign) {
      return <Redirect to={routes.telesign} />;
    } else if (company.defaultStartTab === PortalTab.SAFEMAIL && hasSafeMail) {
      return <Redirect to={routes.safemail} />;
    } else if (company.defaultStartTab === PortalTab.ADMIN) {
      return <Redirect to={routes.admin} />;
    }

    if (hasTeleId) {
      return <Redirect to={routes.teleid} />;
    } else if (hasTeleSign) {
      return <Redirect to={routes.telesign} />;
    } else if (hasSafeMail) {
      return <Redirect to={routes.safemail} />;
    }

    return <Redirect to={routes.teleid} />;
  }

  return <SentryRoute {...props} />;
};

export default UnauthenticatedRoute;
